<ng-container *transloco="let t">
  <div class="flex flex-col gap-3">
    @if (props.label) {
    <p class="font-semibold">
      {{ props.label }}
      <span class="text-red-500" *ngIf="props.required">*</span>
    </p>
    } @if (props.description) {
    <div>{{ props.description }}</div>
    }

    <div class="flex flex-col gap-5 w-full pl-6 relative" [formGroup]="langFormGroup!">
      <!-- Vertical line -->
      <div class="absolute left-0 top-0 w-0.5 bg-surface-200 dark:bg-surface-700 h-full"></div>

      @for (lang of languages; track $index) {
      <div class="flex flex-col gap-1 w-full relative">
        <p class="text-sm text-surface-600 dark:text-surface-400">
          <!-- t(app.formly-types.translatable.enLegend) -->
          <!-- t(app.formly-types.translatable.fiLegend) -->
          <!-- t(app.formly-types.translatable.svLegend) -->
          <!-- t(app.formly-types.translatable.noLegend) -->
          {{ t("app.formly-types.translatable." + lang + "Legend") }}
        </p>
        <input
          [formControlName]="lang"
          [placeholder]="{ fi: 'Finnish', sv: 'Swedish', en: 'English', no: 'Norwegian' }[lang]"
          (blur)="onBlur(lang)"
          [class]="
              'w-full h-12 p-2 border rounded outline-none ' +
              (isFieldInvalid(lang) ? 'border-red-500' : 'border-surface-200 dark:border-surface-700')
            "
          [disabled]="formControl.disabled"
          [ngClass]="{ 'p-disabled': formControl.disabled }"
        />
        @if (isFieldInvalid(lang)) {
        <!-- t(app.formly-types.translatable.enTextRequired) -->
        <!-- t(app.formly-types.translatable.fiTextRequired) -->
        <!-- t(app.formly-types.translatable.svTextRequired) -->
        <!-- t(app.formly-types.translatable.noTextRequired) -->
        <small class="text-red-500">{{ t("app.formly-types.translatable." + lang + "TextRequired") }}</small>
        }
      </div>
      }
    </div>
  </div>
</ng-container>
